



























































































import Vue, { PropType } from 'vue';
import {Joystick} from '@/emulator/EmulatorInfo';
import DataOutput from './DataOutput.vue';

export default Vue.extend({
    name: 'device-joystick',

    components: { DataOutput },

    props: {
        joystick: { type: Object as PropType<Joystick>, required: true },
    },

    computed: {
        state(): number {
            return (+this.joystick.up)
                | (+this.joystick.down  << 1)
                | (+this.joystick.left  << 2)
                | (+this.joystick.right << 3)
                | (+this.joystick.z     << 4)
                | (+this.joystick.x     << 5)
                | (+this.joystick.a     << 6)
                | (+this.joystick.s     << 7);
        },
    },

    methods: {
        parseValue(): number {
            return +(this.$refs.up as HTMLFormElement).checked
                 | +(this.$refs.down as HTMLFormElement).checked  << 1
                 | +(this.$refs.left as HTMLFormElement).checked  << 2
                 | +(this.$refs.right as HTMLFormElement).checked << 3
                 | +(this.$refs.z as HTMLFormElement).checked     << 4
                 | +(this.$refs.x as HTMLFormElement).checked     << 5
                 | +(this.$refs.a as HTMLFormElement).checked     << 6
                 | +(this.$refs.s as HTMLFormElement).checked     << 7;
        },
    },
});
